"use client";
import { useState, useRef, useEffect } from "react";
import { useRouter } from "next/navigation";
import { textColor } from "@/lib/style";
import Link from "next/link";


// import Link from "next/link";
export const AvatarMenu = ({ userEmail }: { userEmail: string }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    const router = useRouter();

    const handleLogout = async () => {
        sessionStorage.removeItem('selectedElementTypeId');

        const response = await fetch('/api/auth/logout', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            router.replace('/login');
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="relative mr-1" ref={menuRef}>
            <div
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="flex items-center justify-center cursor-pointer"
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>

            </div>
            {isMenuOpen && (
                <div className="absolute right-0 mt-2 w-60 rounded-md shadow-lg bg-white dark:bg-gray-800 dark:text-white ring-1 ring-black ring-opacity-5 z-50">
                    <div className="py-1" role="menu" aria-orientation="vertical">
                        {userEmail.endsWith('@workltd.co.uk') && (<>
                            <Link href="/admin/organization">
                                <div
                                    className={`w-full text-left px-4 py-2 ${textColor} hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer`}
                                    role="menuitem"
                                >
                                    Company &amp; Project Settings
                                </div>
                            </Link>
                            <hr className="border-gray-200 dark:border-gray-600" />
                        </>)}
                        {/* {userEmail.endsWith('@workltd.co.uk') && (<>
                            <Link href="/admin/platform">
                                <div
                                    className={`w-full text-left px-4 py-2 ${textColor} hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer`}
                                    role="menuitem"
                                >
                                    Platform Settings
                                </div>
                            </Link>
                            <hr className="border-gray-200 dark:border-gray-600" />
                        </>)} */}
                        <Link href="/profile">
                            <div
                                className={`w-full text-left px-4 py-2 ${textColor} hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer`}
                                role="menuitem"
                            >
                                Profile
                            </div>
                        </Link>
                        <div
                            className={`w-full text-left px-4 py-2 ${textColor} hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer`}
                            role="menuitem"
                            onClick={handleLogout}
                        >
                            Log Out
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};